import LandingShell from './LandingShell';
import { Button } from './ui/button';
import '../pages/Auth.css';

/**
 * AuthShell — shared chrome for login/forgot/reset/confirm.
 * Renders inside LandingShell; children render inside the paper card.
 * `topRightCta` controls the nav button.
 */
const AuthShell = ({ children, topRightCta }) => (
  <LandingShell
    navRight={
      topRightCta ? (
        <Button
          variant={topRightCta.kind === 'ghost' ? 'outline' : 'default'}
          size="sm"
          onClick={topRightCta.onClick}
        >
          {topRightCta.label}
        </Button>
      ) : null
    }
  >
    <div className="auth-main">
      <div className="auth-card">{children}</div>
    </div>
  </LandingShell>
);

export default AuthShell;
